// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delegated-operation-confirm {\n  width: 520px;\n}\n.delegated-operation-confirm .el-message-box__message {\n  word-break: normal;\n  overflow-wrap: break-word;\n}", ""]);
// Exports
module.exports = exports;
